import styled from 'styled-components';
var Highlight = styled.span.withConfig({
  displayName: "TextUtils__Highlight",
  componentId: "sc-5yn1sv-0"
})(["color:", ";"], function (_ref) {
  var color = _ref.color,
      theme = _ref.theme;
  return color ? color : theme.colors.textPrimary;
});
var Normal = styled.span.withConfig({
  displayName: "TextUtils__Normal",
  componentId: "sc-5yn1sv-1"
})(["font-weight:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.inter.normal;
});
var Sup = styled.sup.withConfig({
  displayName: "TextUtils__Sup",
  componentId: "sc-5yn1sv-2"
})(["font-size:0.5em;vertical-align:super;"]);
var Right = styled.span.withConfig({
  displayName: "TextUtils__Right",
  componentId: "sc-5yn1sv-3"
})(["display:block;text-align:right;"]);
var Left = styled.span.withConfig({
  displayName: "TextUtils__Left",
  componentId: "sc-5yn1sv-4"
})(["display:block;text-align:left;"]);
var Center = styled.span.withConfig({
  displayName: "TextUtils__Center",
  componentId: "sc-5yn1sv-5"
})(["display:block;text-align:center;"]);
var Uppercase = styled.span.withConfig({
  displayName: "TextUtils__Uppercase",
  componentId: "sc-5yn1sv-6"
})(["text-transform:uppercase;letter-spacing:0.1em;"]);
var Lowercase = styled.span.withConfig({
  displayName: "TextUtils__Lowercase",
  componentId: "sc-5yn1sv-7"
})(["text-transform:lowercase;"]);
var Capitalize = styled.span.withConfig({
  displayName: "TextUtils__Capitalize",
  componentId: "sc-5yn1sv-8"
})(["text-transform:capitalize;"]);
/**
 * @component
 * Text utilities for formatting and manipulating text.
 */

export default {
  Highlight: Highlight,
  Normal: Normal,
  Right: Right,
  Left: Left,
  Center: Center,
  Uppercase: Uppercase,
  Lowercase: Lowercase,
  Capitalize: Capitalize,
  Sup: Sup
};